export enum BoxPlotDisplayMode {
  Box = "box",
  Jitter = "jitter",
  Violin = "violin"
}

/**
 * The single arbiter for the box plot family's display mode. Violin wins over jitter when both
 * toggles are active (a hydrated dashboard can restore both), and a plain box is the fallback.
 * Every consumer (translator, jitter highlight, lasso, add-to-filter, request builder) derives
 * from this so the "violin wins" rule can never drift between them.
 */
export function resolveBoxPlotDisplayMode({
  jitterActive,
  violinActive
}: {
  jitterActive?: boolean;
  violinActive?: boolean;
}): BoxPlotDisplayMode {
  if (violinActive) return BoxPlotDisplayMode.Violin;
  if (jitterActive) return BoxPlotDisplayMode.Jitter;
  return BoxPlotDisplayMode.Box;
}

/**
 * Jitter and violin place a type well inside one of the x-axis categories, drawn as a
 * diamond, whenever a category can be resolved for its value. When none can be, they fall
 * back to a horizontal line. A plain box always draws the horizontal line, whatever it is
 * grouped by, so its type wells span the whole chart.
 */
export function placesTypeWellsInCategories(mode: BoxPlotDisplayMode): boolean {
  return mode === BoxPlotDisplayMode.Jitter || mode === BoxPlotDisplayMode.Violin;
}
